import { render, staticRenderFns } from "./CartAddressSelected.vue?vue&type=template&id=45f54172&scoped=true"
import script from "./CartAddressSelected.vue?vue&type=script&lang=js"
export * from "./CartAddressSelected.vue?vue&type=script&lang=js"
import style0 from "./CartAddressSelected.vue?vue&type=style&index=0&id=45f54172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f54172",
  null
  
)

export default component.exports